export const EMPTY_ONLINE_METRICS = {
    uniqueConnectedToday: 0,
    uniqueConnected: 0,
    currentlyOnline: 0,
    activeSessions: 0,
    teachersToday: 0,
    studentsToday: 0,
    administrativeToday: 0,
    teachers: 0,
    students: 0,
    administrative: 0,
    devices: {
        mobile: 0,
        desktop: 0,
        total: 0,
        mobilePercent: 0,
        desktopPercent: 0,
    },
    byRole: [
        { key: 'profesor', label: 'Profesor', value: 0 },
        { key: 'estudiante', label: 'Estudiante', value: 0 },
        { key: 'administrativo', label: 'Administrativo', value: 0 },
    ],
    uniqueByDay: [],
    period: 'month',
    userCategory: 'all',
};

export const DEFAULT_CHART_PERIOD = 'month';

export const PERIOD_OPTIONS = [
    { value: 'today', label: 'Hoy' },
    { value: 'last7', label: 'Últimos 7 días' },
    { value: 'month', label: 'Mes actual' },
];

export const USER_CATEGORY_OPTIONS = [
    { value: 'all', label: 'Todos' },
    { value: 'profesor', label: 'Profesor' },
    { value: 'estudiante', label: 'Estudiante' },
    { value: 'administrativo', label: 'Administrativo' },
];

export const DEFAULT_HISTORY_FILTERS = {
    period: DEFAULT_CHART_PERIOD,
    userCategory: 'all',
};

export const historyTitleForPeriod = (period) => {
    if (period === 'today') return 'Histórico de conexiones de hoy';
    if (period === 'last7') return 'Histórico de conexiones · Últimos 7 días';
    return 'Histórico de conexiones de este mes';
};

export const DEVICE_TYPE_LABELS = {
    desktop: 'Desktop',
    mobile: 'Mobile',
    tablet: 'Mobile',
};

export const ROLE_CHART_COLORS = {
    profesor: '#3b82f6',
    estudiante: '#a78bfa',
    administrativo: '#2dd4bf',
};

export const DEVICE_CHART_COLORS = {
    mobile: '#3b82f6',
    desktop: '#2dd4bf',
};

export const CHART_ACCENT = '#7c3aed';
export const CHART_MUTED = '#e2e8f0';

export const MEXICO_TZ = 'America/Mexico_City';

export const formatDeviceType = (deviceType) => (
    DEVICE_TYPE_LABELS[deviceType] || DEVICE_TYPE_LABELS.desktop
);

export const formatOsLabel = (os) => {
    const value = String(os || '').trim();
    if (!value || value.toLowerCase() === 'desconocido') return 'Desconocido';
    return value;
};

export const formatMexicoTime = (value) => {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        timeZone: MEXICO_TZ,
    });
};

export const formatMexicoDate = (value) => {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        timeZone: MEXICO_TZ,
    });
};

export const formatMexicoDateTime = (value) => {
    if (!value) return { date: '', time: '' };
    return {
        date: formatMexicoDate(value),
        time: formatMexicoTime(value),
    };
};

export const formatDuration = (durationMs) => {
    const totalMinutes = Math.max(0, Math.round(Number(durationMs || 0) / 60000));
    if (totalMinutes < 1) return 'Menos de 1 min';
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    if (hours === 0) return `${minutes} min`;
    if (minutes === 0) return `${hours} h`;
    return `${hours} h ${minutes} min`;
};

/** Normaliza métricas de API a la forma esperada por las cards. */
export const normalizeChartMetrics = (metrics, period) => ({
    ...EMPTY_ONLINE_METRICS,
    ...(metrics || {}),
    period,
    userCategory: 'all',
});
